import { render, staticRenderFns } from "./model-r1-layer-edit.vue?vue&type=template&id=70014ffb&scoped=true&"
import script from "./model-r1-layer-edit.vue?vue&type=script&lang=js&"
export * from "./model-r1-layer-edit.vue?vue&type=script&lang=js&"
import style0 from "./model-r1-layer-edit.vue?vue&type=style&index=0&id=70014ffb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70014ffb",
  null
  
)

export default component.exports